// MrdDocument.tsx

import React from 'react'
import Page from '../../../layout/Page'
import { Modal, Icon, Button, DropdownItemProps, Segment } from 'semantic-ui-react'
import DocumentPendency from '../../../../models/DocumentPendency'
import Result from '../../../../common/repository/Result'
import { toast } from '../../../common/Toast'
import Table from '../../../app/Table'
import RequirePermission from '../../../base/RequirePermission'
import permissions from '../../../../common/permissions'
import Filters from './Filters'
import FilterPageContext from './FilterPageContext'
import ClientRepository from '../../../../common/repository/ClientRepository'
import UserRepository from '../../../../common/repository/UserRepository'
import constants from '../../../../common/constants'
import UploadDocumentPendencyForm from './UploadDocumentPendencyForm'
import MrdDocumentFormColumnRenderer from './MrdDocumentFormColumnRenderer'
import MrdDocuments from '../../../../models/MrdDocuments'
import MrdDocumentForm from './MrdDocumentDownloadForm'
import DocumentMrdRepository, { GetMrdDocumentRequestObject } from '../../../../common/repository/DocumentMrdRepository'
import DocumenMrdForm from './DocumenMrdForm'

interface State {
  loading: boolean

  filter: string
  limit: number
  offset: number
  totalCount: number
  mrdDocuments: MrdDocuments[]

  update_modalOpen: boolean
  update_model: MrdDocuments | null

  remove_modalOpen: boolean
  remove_model: MrdDocuments | null

  loadingEssentialData: boolean
  userOptions: DropdownItemProps[]
  userFilter: string
  claimNumberFilter: string
  fromFilter: string
  toFilter: string
  downloadTemplateModalOpen: boolean
  uploadTemplateModalOpen: boolean
}

class MrdDocument extends React.Component<{}, State> {
  private mrdDocRepo = new DocumentMrdRepository()
  private userRepo = new UserRepository()
  private filters: any

  private columnRenderer = new MrdDocumentFormColumnRenderer(
    (model: MrdDocuments) => (
      <Button.Group size="mini">
        <Button onClick={() => {
          this.setState({ update_modalOpen: true , update_model: model})
          }
        }>Open</Button>
      </Button.Group>
    ),
    (obj: any) => true
  )
  onDocumentPendencyUpdated: any

  constructor(props: any) {
    super(props)

    this.filters = props.history?.location?.state
    this.state = {
      loading: false,
      limit: 10,
      offset: 0,
      filter: '',
      totalCount: 0,
      mrdDocuments: [],
      update_modalOpen: false,
      update_model: null,
      remove_modalOpen: false,
      remove_model: null,

      loadingEssentialData: true,
      userOptions: [],
      userFilter: '',
      claimNumberFilter: '',
      fromFilter: '',
      toFilter: '',
      downloadTemplateModalOpen: false,
      uploadTemplateModalOpen: false
    }
  }

  async componentDidMount() {
    this.loadData()
    await this.effectLoadEssentialData()
  }

  private onRowsPerPageChange = (page: number, rowsPerPage: number) => {
    const offset = (page - 1) * rowsPerPage,
      limit = offset + rowsPerPage
    this.setState({ offset, limit }, this.loadData)
  }

  private setFilter = (filter: string) => {
    console.log('Claim Number filter:', filter);
  
    this.setState({ claimNumberFilter: filter, offset: 0 }, this.loadData);
  }
  

  private clearAllFilters = async () => {
    this.setState(
      {
        userFilter: '',
        claimNumberFilter: '',
        fromFilter: '',
        toFilter: '',
      },
      this.loadData
    )
  }

  private getMrdDocumentPendency = async () => {
    const ro: GetMrdDocumentRequestObject = {
      limit: this.state.limit,
      offset: this.state.offset,
      claimNumber: this.state.claimNumberFilter,      
      to: this.state.toFilter || undefined,
      from: this.state.fromFilter || undefined,
      user: this.state.userFilter || undefined,
    };
    return await this.mrdDocRepo.getDataMrd(ro);
  };
  

 private loadData = async () => {
  this.setState({ loading: true }, async () => {
    const result = await this.getMrdDocumentPendency();

    if (result instanceof Result.Success) {
      const mrdDocuments = result.data.items;
      const totalCount = result.data.totalItemCount;
   

      this.setState({
        loading: false,
        offset: mrdDocuments.length,
    
        mrdDocuments, 
        totalCount
      });
    } 
    else {
      const message = result.message || 'Something went wrong';
      this.setState({ loading: false }, () => toast.error(message));
    }
  });
};


  private effectLoadEssentialData = async () => {
    if (!this.state.loadingEssentialData) return

    let userRole = constants.roleTitle.investigator
    const p1 = this.userRepo.getUsers({ role: userRole, is_active: true })

    const results = await Promise.all([p1])

    if (results[0] instanceof Result.Success) {
      this.setState({
        userOptions: results[0].data.items.map((it) => ({
          text: it.getName(),
          value: it.getId(),
          key: it.getId(),
        })),
      })
    } else {
      toast.error(results[0].message || 'Could not load Users')
    }

    this.setState({ loadingEssentialData: false })
  }

  private setUserFilter = (val: string) => this.setState({ userFilter: val })
  private setClaimNumberFilter = (val: string) => this.setState({ claimNumberFilter: val })
  private setFromFilter = (val: string) => this.setState({ fromFilter: val })
  private setToFilter = (val: string) => this.setState({ toFilter: val })

  render() {
    return (
      <FilterPageContext.Provider
        value={{
          options: {
            user: this.state.userOptions,
          },
          filters: {
            user: this.state.userFilter,
            setUser: this.setUserFilter,
            claimNumber: this.state.claimNumberFilter,
            setClaimNumber: this.setClaimNumberFilter,
            from: this.state.fromFilter,
            setFrom: this.setFromFilter,
            to: this.state.toFilter,
            setTo: this.setToFilter,
            applyFilters: this.loadData,
            clearAllFilters: this.clearAllFilters,
          },
        }}
      >
        <Page title="Mrd Upload" description="Update cases whose Mrd documents Payment are arrived">
          <Segment.Group>
            <Segment>
              <Modal
                open={this.state.downloadTemplateModalOpen}
                size="mini"
                closeIcon
                onClose={() => this.setState({ downloadTemplateModalOpen: false })}
                closeOnDimmerClick={false}
                closeOnEscape={false}
                trigger={
                  <span>
                    <label style={{ marginRight: 16 }}>Step 1:</label>
                    <Button primary onClick={() => this.setState({ downloadTemplateModalOpen: true })}>
                      Download Template
                    </Button>
                  </span>
                }
              >
                <Modal.Header>Download Template</Modal.Header>
                <Modal.Content>
                  <MrdDocumentForm onSuccess={() => this.setState({ downloadTemplateModalOpen: false })} />
                </Modal.Content>
              </Modal>

              <Icon name="arrow right" style={{ margin: '0 2rem' }} />
              <label>Step 2: Fill it.</label>
              <Icon name="arrow right" style={{ margin: '0 2rem' }} />

              <Modal
                open={this.state.uploadTemplateModalOpen}
                size="mini"
                closeIcon
                closeOnDimmerClick={false}
                closeOnEscape={false}
                onClose={() => this.setState({ uploadTemplateModalOpen: false })}
                trigger={
                  <span>
                    <label style={{ marginRight: 16 }}>Step 3:</label>
                    <Button primary onClick={() => this.setState({ uploadTemplateModalOpen: true })}>
                      Upload MRD Document Template
                    </Button>
                  </span>
                }
              >
                <Modal.Header>Upload MRD Document Template</Modal.Header>
                <Modal.Content>
                  <UploadDocumentPendencyForm
                    onSuccess={() => {
                      this.setState({ uploadTemplateModalOpen: false })
                      this.loadData()
                    }}
                  />
                </Modal.Content>
              </Modal>

            </Segment>
          </Segment.Group>

          {/* <Segment>
            {/* <Filters /> */}
          {/* </Segment> */} 
          <Modal
            open={this.state.update_modalOpen}
            onClose={() =>
              this.setState({
                update_modalOpen: false,
                update_model: null,
              })
            }
            size="tiny"
            closeIcon
            closeOnDimmerClick={false}
            closeOnEscape={false}
          >
            <Modal.Header>Update Information</Modal.Header>
            <Modal.Content>
              <DocumenMrdForm
                model={this.state.update_model || undefined}
                onSuccess={this.onDocumentPendencyUpdated}
                onError={() => this.setState({ update_modalOpen: false })}
              />
            </Modal.Content>
          </Modal>
          <Table
            renderer={this.columnRenderer}
            data={this.state.mrdDocuments}
            totalDataCount={this.state.totalCount}
            loading={this.state.loading}
            load={this.loadData}
            onSearch={this.setFilter}
            onRowsPerPageChange={this.onRowsPerPageChange}
            onClear={() => this.setFilter('')}
            
          />
        </Page>
      </FilterPageContext.Provider>
    )
  }
}

export default (props: any) => (
  <RequirePermission permission={permissions.Billing.update}>
    <MrdDocument {...props} />
  </RequirePermission>
)
